module.exports = __webpack_public_path__ + "img/park.54f49c30.png";